import IsAuthenticated from "@/components/middleware/isAuthenticated";
import IsGuestUser from "@/components/middleware/isGuestUser";
import { Dashboard, Login, SubmittedBids } from "@/pages";
import { ForgotPassword } from "@/pages/auth";
import ResetPassword from "@/pages/auth/reset-password";
import {
  SettingsPage,
  NotificationsPage,
  PurchaseOrderPage,
} from "@/pages/protected";
import routesPath from "@/utils/routesPath";
import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

const {
  DASHBOARD,
  LOGIN,
  FORGOT_PASSWORD,
  SETTINGS,
  NOTIFICATIONS,
  SUBMITTED_BIDS,
  PURCHASE_ORDER,
  RESET_PASSWORD,
} = routesPath;
export default function AppRoute() {
  return (
    <Suspense>
      <Routes>
        <Route path={FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={RESET_PASSWORD} element={<ResetPassword />} />
        <Route element={<IsGuestUser />}>
          <Route path={LOGIN} element={<Login />} />
        </Route>
        <Route element={<IsAuthenticated />}>
          <Route path={DASHBOARD} element={<Dashboard />} />
          <Route path={SUBMITTED_BIDS} element={<SubmittedBids />} />
          <Route path={PURCHASE_ORDER} element={<PurchaseOrderPage />} />
          <Route path={SETTINGS} element={<SettingsPage />} />
          <Route path={NOTIFICATIONS} element={<NotificationsPage />} />
        </Route>
      </Routes>
      <Toaster richColors position="top-right" />
    </Suspense>
  );
}
